import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GeneralSidebarComponent } from "../../../components/general-sidebar/general-sidebar.component";
import { LoggedInHeaderComponent } from "../../../components/logged-in-header/logged-in-header.component";
import { DashboardComponent } from "../../../components/dashboard/dashboard.component";
import { MonthlyChartComponent } from '../../../components/monthly-chart/monthly-chart.component';
import { CategoryChartComponent } from '../../../components/category-chart/category-chart.component';
import {
  MonthlyRegistration,
  StatCard,
  VendorCategory,
} from '../../../models/dashboard.model';
import { PageHeaderComponent } from '../../../components/page-header/page-header.component';
import { StatsGridComponent } from '../../../components/stats-grid/stats-grid.component';
import { ActivityFeedComponent } from '../../../components/activity-feed/activity-feed.component';
import { ActivityItem } from '../../../models/dashboard.model';
import { MetricsService } from '../../../modules/services/metrics.service';
import { AuthenticationService } from '../../../modules/services/authentication.service';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    PageHeaderComponent,
    StatsGridComponent,
    MonthlyChartComponent,
    CategoryChartComponent,
    ActivityFeedComponent,
  ],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent implements OnInit {
  welcomeSubtitle = "Welcome back, User! Here's what's happening today.";
  statCards: StatCard[] = [
    {
      title: 'Total Revenue Collected',
      value: 'N/A',
      change: '',
      changeType: 'positive',
      subtitle: 'All Time',
    },
    {
      title: 'Total Vendors',
      value: 'N/A',
      change: '',
      changeType: 'positive',
      subtitle: 'All Time',
    },
    {
      title: 'Total Pending Approvals',
      value: 'N/A',
      change: '',
      changeType: 'warning',
      subtitle: '',
    },
  ];
  monthlyRevenueTrend: MonthlyRegistration[] = [];

  vendorCategories: VendorCategory[] = [];

  readonly recentActivities: ActivityItem[] = [
    {
      id: 1,
      user: 'Ngozi M.',
      action: 'created',
      target: 'Beta Services Nigeria Ltd',
      date: '20 Mar',
      time: '11:15',
      actionType: 'created',
    },
    {
      id: 2,
      user: 'Dr. Adeyemi',
      action: 'approved',
      target: 'Alpha Engineering Ltd',
      date: '16 Jan',
      time: '14:20',
      actionType: 'approved',
    },
    {
      id: 3,
      user: 'Chijioke O.',
      action: 'created',
      target: 'Alpha Engineering Ltd',
      date: '15 Jan',
      time: '09:30',
      actionType: 'created',
    },
    {
      id: 4,
      user: 'Ngozi M.',
      action: 'created',
      target: 'Beta Services Nigeria Ltd',
      date: '8 Mar',
      time: '11:15',
      actionType: 'created',
    },
  ];

  private vendorsSummaryLoaded = false;
  private dashboardSummaryLoaded = false;
  private revenueSummaryLoaded = false;
  private revenueTrendLoaded = false;
  private vendorsByCategoryLoaded = false;

  constructor(
    private readonly metricsService: MetricsService,
    private readonly authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    const fullName = this.authenticationService.getAuthenticatedUser()?.name?.trim() || 'User';
    const firstName = fullName.split(/\s+/).filter(Boolean)[0] || 'User';
    this.welcomeSubtitle = `Welcome back, ${firstName}! Here's what's happening today.`;
    this.loadMetrics();
  }

  private loadMetrics(): void {
    // this.metricsService.getRevenueSummary('month').subscribe({
    //   next: (summary) => {
    //     const total = Number(summary?.totalRevenue ?? NaN);
    //     const changeValue = Number(summary?.comparativeChange?.value ?? NaN);
    //     const isPercentage = Boolean(summary?.comparativeChange?.percentage);

    //     this.setStatCard('Total Revenue Collected', {
    //       value: Number.isFinite(total) ? this.formatCurrency(total) : 'N/A',
    //       change: this.formatChange(changeValue, isPercentage),
    //     });
    //     this.revenueSummaryLoaded = true;
    //   },
    //   error: () => {
    //     if (!this.revenueSummaryLoaded) {
    //       this.setStatCard('Total Revenue Collected', { value: 'N/A', change: '' });
    //     }
    //   },
    // });

    // this.metricsService.getVendorsSummary().subscribe({
    //   next: (summary) => {
    //     const total = Number(summary?.totalVendors ?? NaN);
    //     const newThisWeek = Number(summary?.newThisWeek ?? NaN);
    //     this.setStatCard('Total Vendors', {
    //       value: Number.isFinite(total) ? total.toLocaleString('en-NG') : 'N/A',
    //       change: Number.isFinite(newThisWeek) ? `+${newThisWeek}` : '',
    //     });
    //     this.vendorsSummaryLoaded = true;
    //   },
    //   error: () => {
    //     if (!this.vendorsSummaryLoaded) {
    //       this.setStatCard('Total Vendors', { value: 'N/A', change: '' });
    //     }
    //   },
    // });

    this.metricsService.getDashboardSummary().subscribe({
      next: (summary) => {
        const totalRevenue = Number(summary?.revenue?.total ?? NaN);
        const totalVendors = Number(summary?.vendors?.total ?? NaN);
        const pending = Number(summary?.approvals?.pending ?? NaN);
        const requiresAction = Boolean(summary?.approvals?.requiresAction);
        this.setStatCard('Total Pending Approvals', {
          value: Number.isFinite(pending) ? pending.toLocaleString('en-NG') : 'N/A',
          change: requiresAction ? 'Requires action' : '',
        });

        this.setStatCard('Total Revenue Collected', {
          value: Number.isFinite(totalRevenue) ? this.formatCurrency(totalRevenue) : 'N/A',
          change: this.formatChange(summary?.revenue?.percentageChange, true),
        });


        this.setStatCard('Total Vendors', {
          value: Number.isFinite(totalVendors) ? totalVendors.toLocaleString('en-NG') : 'N/A',
          change: this.formatChange(0, true),
        });
        this.dashboardSummaryLoaded = true;
      },
      error: () => {
        if (!this.dashboardSummaryLoaded) {
          this.setStatCard('Total Pending Approvals', { value: 'N/A', change: '' });
        }
      },
    });

    this.metricsService.getRevenueTrend(12).subscribe({
      next: (payload) => {
        const trend = Array.isArray(payload?.trend) ? payload.trend : [];
        const mapped = trend
          .map((item) => {
            const rawPeriod = String(item?.period ?? '').trim();
            return {
              rawPeriod,
              label: this.formatRevenuePeriod(rawPeriod),
              revenue: Number(item?.revenue ?? 0),
            };
          })
          .filter((r) => r.label)
          .sort((a, b) => a.rawPeriod.localeCompare(b.rawPeriod))
          .map((r) => ({ month: r.label, count: r.revenue }));

        this.monthlyRevenueTrend = mapped;
        this.revenueTrendLoaded = true;
      },
      error: () => {
        if (!this.revenueTrendLoaded) {
          this.monthlyRevenueTrend = [];
        }
      },
    });

    this.metricsService.getVendorsByCategory().subscribe({
      next: (res) => {
        const distribution = Array.isArray(res?.distribution) ? res.distribution : [];
        const palette = ['#10B981', '#F59E0B', '#3B82F6', '#3B82A0', '#8B5CF6', '#EF4444'];
        const mapped = distribution
          .map((item, index) => ({
            name: String(item?.category ?? '').trim(),
            count: Number(item?.count ?? 0),
            color: palette[index % palette.length],
          }))
          .filter((c) => c.name && c.count > 0);

        this.vendorCategories = mapped;
        this.vendorsByCategoryLoaded = true;
      },
      error: () => {
        if (!this.vendorsByCategoryLoaded) {
          this.vendorCategories = [];
        }
      },
    });
  }

  private setStatCard(title: StatCard['title'], patch: Partial<StatCard>): void {
    const index = this.statCards.findIndex((c) => c.title === title);
    if (index === -1) return;
    this.statCards = this.statCards.map((card, i) => (i === index ? { ...card, ...patch } : card));
  }

  private formatRevenuePeriod(value: string): string {
    const trimmed = value.trim();
    if (!/^\d{4}-\d{2}$/.test(trimmed)) return '';
    const [year, month] = trimmed.split('-').map((v) => Number(v));
    if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) return '';
    const date = new Date(Date.UTC(year, month - 1, 1));
    const monthLabel = date.toLocaleString('en-US', { month: 'short' });
    const yearLabel = String(year).slice(-2);
    return `${monthLabel} \u2019${yearLabel}`;
  }

  private formatCurrency(amount: number): string {
    if (!Number.isFinite(amount)) return '₦0';
    return `₦${Math.round(amount).toLocaleString('en-NG')}`;
  }

  private formatChange(value: number, isPercentage: boolean): string {
    if (!Number.isFinite(value) || value === 0) return '';
    const sign = value > 0 ? '+' : '';
    return isPercentage ? `${sign}${value}%` : `${sign}${value}`;
  }
}
